import { render } from "./FinishScreen.vue?vue&type=template&id=33dabfda"
import script from "./FinishScreen.vue?vue&type=script&lang=js"
export * from "./FinishScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/scania_guess_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__